import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import MainButton from '@configuratorware/configurator-frontendgui/Shared/Components/MainButton';
import { T } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import getImageUrl from '@configuratorware/configurator-frontendgui/App/Utils/getImageUrl';

const useStyles = makeStyles(
  () => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '5px',
      width: '80%',
      backgroundColor: '#fff',
      padding: '25px',
      margin: '20px',
      boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.2)',
    },
    image: {
      marginTop: '10px',
      width: '90%',
      height: '190px',
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
      },
    },
    progress: {
      margin: 'auto',
      width: '70%',
      height: '170px',
    },
    title: {
      wordWrap: 'break-word',
      margin: 'auto',
      height: '40%',
      width: '100%',
      fontSize: '1rem',
    },
    buttonContainer: {
      width: '90%',
      margin: 'auto',
      marginTop: '25px',
    },
    abstractContainer: {
      width: '90%',
      marginTop: '15px',
      marginBottom: 0,
    },
  }),
  { name: 'ItemTile' }
);

const ItemTile = ({ title, linkTo, image, abstract }) => {
  const classes = useStyles();
  const history = useHistory();
  const [loadState, setLoadState] = useState(true);

  const handleClick = async (link) => {
    try {
      history.push(link);
    } catch (e) {
      alert(`could not load configuration: ${linkTo}`);
    }
  };

  return (
    <div className={classes.root}>
      <Typography variant="h6" className={classes.title}>
        {title}
      </Typography>
      {loadState && <CircularProgress className={classes.progress} />}
      <div className={classes.image}>
        <img
          src={getImageUrl(image)}
          alt={title}
          onLoad={() => setLoadState(false)}
          onError={() => setLoadState(false)}
        />
      </div>
      {abstract && (
        <div className={classes.abstractContainer}>
          <Typography variant="body2">{`(${linkTo})`}</Typography>
          <Typography variant="body2">{abstract}</Typography>
        </div>
      )}

      <div className={classes.buttonContainer}>
        <MainButton
          style={{ backgroundColor: 'black' }}
          fullWidth
          onClick={() => handleClick(`/identifier:${linkTo}`)}
        >
          {T('itemOverview.customize')}
        </MainButton>
      </div>
    </div>
  );
};

ItemTile.defaultProps = {
  title: '',
  linkTo: '',
  image: '',
};

ItemTile.propTypes = {
  title: PropTypes.string,
  linkTo: PropTypes.string,
  image: PropTypes.string,
  abstract: PropTypes.string,
};

export default ItemTile;
